import { SystemLoaderFacade } from 'src/app/store/system-loader/facade/system-loader.facade';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { DynamicComponentHostDirective } from './components/shared/dynamic-component-loader/dynamic-component-host.directive';
import { AppConfig } from 'src/app/app.config';
import { Component, ViewChild } from '@angular/core';

@UntilDestroy()
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
})
export class AppComponent {
    @ViewChild(DynamicComponentHostDirective, { static: true }) dynamicComponentHost: DynamicComponentHostDirective;

    public isLoading: boolean;
    private isLoading$: Observable<boolean> = this.systemLoaderFacade.isLoading$;
    private isLoadingSubscription = this.isLoading$.pipe(untilDestroyed(this)).subscribe((isLoading: boolean) => {
        setTimeout(() => {
            this.isLoading = isLoading;
        });
    });

    constructor(private appConfig: AppConfig, private systemLoaderFacade: SystemLoaderFacade) {
        document.title = this.appConfig.getEnvironment().name;
    }
}

